import { isValue } from '../../../utility/isValue';
export const round = (value) => Math.round(value * 100) / 100;
import calculateField from '../../../components/formBuilder/utility/calculateFields';

export default function graphDataFormatter(
  years,
  purchaseData,
  buyAndHoldData,
  brrrrData,
  fieldName,
  buyAndHoldFieldName = null,
  brrrrFieldName = null,
  type = 'comparison',
  graphSelectOption = null
) {
  const result = [];

  for (let year = 1; year <= years; year++) {
    const purchaseYearData = purchaseData[year - 1];
    const buyAndHoldYearData = buyAndHoldData[year - 1];
    const brrrrYearData = brrrrData[year - 1];

    if (type === 'comparison') {
      const yearData = {
        date: `Year ${year}`,
        'On Purchase': round(purchaseYearData?.[fieldName]),
        'Buy and Hold': round(
          buyAndHoldYearData?.[buyAndHoldFieldName || fieldName]
        ),
        'BRRRR Scenario': brrrrYearData?.[brrrrFieldName]
          ? round(brrrrYearData?.[brrrrFieldName])
          : brrrrYearData?.[buyAndHoldFieldName || fieldName],
      };

      result.push(yearData);
    } else if (type === 'single') {
      if (!graphSelectOption || graphSelectOption?.type !== 'stack') {
        let value = isValue(purchaseYearData?.[fieldName])
          ? purchaseYearData?.[fieldName]
          : isValue(purchaseYearData?.[buyAndHoldFieldName])
          ? purchaseYearData?.[buyAndHoldFieldName]
          : null;

        value = round(value);
        const yearData = {
          date: `Year ${year}`,
          Value: value,
        };
        result.push(yearData);
        //implementation to handle stack graph , includes an option to calculate the value based on other fields
      } else if (graphSelectOption?.type === 'stack') {
        const yearData = {
          date: `Year ${year}`,
        };

        for (const stack of graphSelectOption.stackIncludes) {
          const stackValue = stack.derivedFrom
            ? calculateField(stack, purchaseYearData)
            : purchaseYearData?.[stack.name]
            ? purchaseYearData?.[stack.name]
            : purchaseYearData?.[stack.altName]
            ? purchaseYearData?.[stack.altName]
            : null;

          yearData[stack.label] = round(stackValue);
        }

        result.push(yearData);
      }
    }
  }

  return result;
}
